interface RadioButtonExpanderProps {
  isExpanded: boolean;
  onClick: () => void;
}

export const RadioButtonExpander = ({ isExpanded, onClick }: RadioButtonExpanderProps) => {
  if (!isExpanded) {
    return (
      <svg onClick={onClick} width="45" height="45" viewBox="0 0 45 45" className={`fill-interactive-coral hover:fill-solid-bold-green inline-block ml-2 w-4`} xmlns="http://www.w3.org/2000/svg">
        <path d="M25.4312 19.5869L25.5038 0.0314517L20.6149 0.0133064L20.5423 19.5687L0.986914 19.4961L0.968769 24.385L20.5242 24.4576L20.4516 44.013L25.3405 44.0311L25.413 24.4757L44.9685 24.5483L44.9866 19.6595L25.4312 19.5869Z" />
      </svg>
    );
  } else {
    return (
      <svg onClick={onClick} width="44" height="5" viewBox="0 0 44 5" className={`fill-interactive-coral hover:fill-solid-bold-green inline-block ml-2 w-4`} xmlns="http://www.w3.org/2000/svg">
        <path d="M44 0V4.29268H0V0H44Z" />
      </svg>
    );
  }
};
